import { environment } from '@/assets/environment';
import { RequestEssenceType } from '@/models/entities/request-essence.model';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { IAboutBuyState } from '@/models/store/about-how-buy/about-buy-state.model';
import { IAboutBuy } from '@/models/store/about-how-buy/about-buy.model';
import { isEqual } from 'lodash';
import { Module } from 'vuex';

const aboutHowBuyModule: Module<IAboutBuyState, unknown> = {
    state: {
        aboutItems: [],
        howToBuyItems: [],
    },

    actions: {
        fetchAboutBuy: async ({ commit }, payload: RequestEssenceType) => {
            const params = new URLSearchParams();
            params.append('type', payload);

            const response = await fetch(`${environment.baseUrl}/api/about-how-to-buy?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const essences = (await response.json()).data;
            if (isEqual(payload, 'about')) commit('setAbout', essences);
            if (isEqual(payload, 'buy')) commit('setBuy', essences);
        },
    },

    mutations: {
        setAbout: (store, payload: IAboutBuy[]) => {
            store.aboutItems = [...payload];
        },

        setBuy: (store, payload: IAboutBuy[]) => {
            store.howToBuyItems = [...payload];
        },
    },

    getters: {
        getAbout: (store) => store.aboutItems,
        getHowBuy: (store) => store.howToBuyItems,
    },
};

export default aboutHowBuyModule;
